module.exports = __webpack_public_path__ + "img/jc.e23a3f10.png";